'use client';

import { createAuthClient } from 'better-auth/react';

const coreApiUrl = import.meta.env.VITE_CORE_API_URL;

export const authClient = createAuthClient({
  baseURL: coreApiUrl,
  basePath: '/auth',
});

// Only used for Google OAuth redirect
export const { signIn } = authClient;
